import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input } from '@innowise-group/mui-kit';

interface SyncEventFormProps {
  isLoading: boolean;
}

const SyncEventForm: React.FC<SyncEventFormProps> = ({ isLoading }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Controller
      name="id"
      control={control}
      render={({ field: { value, onChange }, formState: { errors } }) => (
        <Input
          value={value}
          onChange={onChange}
          disabled={isLoading}
          required
          placeholder={t('common.labels.candidateId')}
          error={!!errors?.id?.message}
          helperText={errors?.id?.message?.toString()}
        />
      )}
    />
  );
};

export default SyncEventForm;
